// State ======================
import lmsActions from "../api/LmsActions.js"
import lmsMutations from "../api/LmsMutations.js"
import lmsGetters from "../api/LmsGetters.js"
export const namespaced = true

export const state = () => ({
  type: "lmsCourses",
  pageLayout: "StructureTable",
  relations: [
    {
      name: "lmsSections",
      value: "lmsSections",
      translate: "sections",
      export: false
    },
    {
      name: "lmsLessons",
      value: "lmsLessons",
      translate: "lessons",
      export: false
    },
    {
      name: "lmsFiles",
      value: "lmsFiles",
      translate: "files",
      export: false
    },
    {
      name: "lmsUsers",
      value: "lmsUsers",
      translate: "users",
      export: false
    }
  ],
  all: {},
  reference: {},
  active: false,
  page: 1,
  pageCount: 0,
  pagination: {
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    itemsPerPage: 100,
    sort: true,
    sortBy: "title",
    page: 1,
    sortDesc: []
  },
  crumbName: _ => _.title,
  total: 0,
  print: false,
  print_path: "",
  export: false,
  search: null,
  bound: {},
  stub: {
    lmsSections: [],
    lmsLessons: [],
    lmsFiles: [],
    users: []
  },
  filter: {},
  include: ["users", "cover"],
  headers: {},
  notifications: {}
})

// Mutations ==================

export const mutations = {
  ...lmsMutations
}

// Actions ====================

export const actions = {
  ...lmsActions
}

// Getters ====================

export const getters = {
  ...lmsGetters
}

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
